// @ts-nocheck
import { Icon } from '@iconify/react';
import * as React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import arrowIosBackFill from '@iconify/icons-eva/arrow-ios-back-fill';
// material
import { useTheme, styled } from '@mui/material/styles';
import { Box, Paper, Stack, Card, Button, Collapse, TextField, IconButton, Typography, GridLegacy as Grid,  } from '@mui/material';
import plusFill from '@iconify/icons-eva/plus-fill';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { useEffect, useState } from 'react';


// components
import Page from '../../../components/Page';
import { VerifyCodeForm } from '../../../components/authentication/verify-code';
import BottomButtons from './BottomButtons';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function VerifyCode({loading, handleUpdate, handleCancel, section, toast}) {
    
  const theme = useTheme();
  const isLight = theme.palette.mode === 'light';
  const fileInputRef = React.useRef(null);

  let [question, setQuestion] = useState('');
  useEffect(()=>{
      if(section && section.jobsiteQuestion){
          let questionData = JSON.parse(section.jobsiteQuestion);
          if(questionData.question)
            setQuestion(questionData.question);
      }
  },[section])
  

  const handleSubmit = e=>{
      if(question.trim().length>0){
          handleUpdate({question});
      }else{
        toast('warning', 'Enter a valid question title!');
      }
  }


    
  return (
    <div>
        <TextField value={question} fullWidth sx={{my:1}} onChange={e=>setQuestion(e.target.value)} id="b-card-name" label="Question title" variant="outlined" />
        <BottomButtons handleCancel={handleCancel} loading={loading} handleSubmit={handleSubmit}  />
    </div>
  );
}